import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { RemoteRefreshSchedules } from '~src/extractRefresh/resources/RemoteRefreshSchedules';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { RemoteRefreshScheduleContentType } from '~src/spacesPlatform/models/ContentTypes';
import { LocallySortingScheduleResourceQuery } from '~src/ts/helpers/LocallySortingScheduleResourceQuery';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

// TFS 829185
export const RemoteRefreshSchedulesDefinition: ExplorableItemDefinition = {
  itemType: 'remoteRefreshSchedule',
  pluralName: Messages.extractTasks,
  singularName: Messages.extractTask,
  emptyStateMessage: Messages.extractTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['remoteRefreshSchedule']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    const resourceQuery = RemoteRefreshSchedules.all().withExtraParams(RemoteRefreshScheduleContentType.extraQueryParams);
    return new LocallySortingScheduleResourceQuery(resourceQuery);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
